export default __webpack_public_path__ + "static/media/hostel.34f0c178.png";